import { memo } from 'react';

import {
  BoxLogoIcon,
  BrandfolderLogoIcon,
  CantoIcon,
  DropboxIcon,
  FrameIoIcon,
  GoogleDriveIcon,
  SharePointIcon,
} from '@air/design-icons';
import { cn } from '@air/utils-tailwind';

import { BOX_ICON_COLORS, DROPBOX_ICON_COLORS } from '~/constants/vendorLogoColors';

export type ImportIconProps = {
  isActive: boolean;
  className?: string;
};

export const GoogleDriveImportIcon = ({ isActive, className }: ImportIconProps) => {
  return (
    <GoogleDriveIcon
      className={cn('mr-2.5 ads:text-icon-subtle text-gray-9', isActive ? '' : '[&>path]:fill-gray-9', className)}
      size="lg"
    />
  );
};

export const DropboxImportIcon = ({ isActive, className }: ImportIconProps) => {
  return (
    <DropboxIcon
      className={cn('mr-2.5', !isActive && 'opacity-60', className)}
      color={DROPBOX_ICON_COLORS.hex}
      size="lg"
    />
  );
};

export const HomeBoxImportIcon = ({ isActive, className }: ImportIconProps) => {
  return (
    <BoxLogoIcon className={cn('mr-2.5', !isActive && 'opacity-60', className)} color={BOX_ICON_COLORS.hex} size="lg" />
  );
};

export const BrandfolderImportIcon = ({ isActive, className }: ImportIconProps) => {
  return (
    <BrandfolderLogoIcon
      className={cn('mr-2.5 ads:text-icon-subtle text-gray-9', isActive ? 'text-[#0061FF]' : '', className)}
      size="lg"
    />
  );
};

export const SharePointImportIcon = ({ isActive, className }: ImportIconProps) => {
  return (
    <SharePointIcon
      className={cn('mr-2.5 ads:text-icon-subtle text-gray-9', isActive ? '' : 'opacity-60 grayscale', className)}
      size="lg"
    />
  );
};

export const FrameIoImportIcon = memo(({ isActive, className }: ImportIconProps) => {
  return (
    <FrameIoIcon
      className={cn('mr-2.5 ads:text-icon-subtle text-gray-9', isActive ? '' : 'opacity-60 grayscale', className)}
      size="lg"
    />
  );
});

FrameIoImportIcon.displayName = 'FrameIoImportIcon';

export const CantoImportIcon = memo(({ isActive, className }: ImportIconProps) => {
  return (
    <CantoIcon
      className={cn('mr-2.5 ads:text-icon-subtle text-gray-9', isActive ? '' : 'opacity-60 grayscale', className)}
      size="lg"
    />
  );
});

CantoImportIcon.displayName = 'CantoImportIcon';
